<div class="chipset" *ngIf="gridFilters">
    <span *ngFor="let gridFilter of gridFilters">
        <div class="mx-3 chip-item" *ngIf="gridFilter.filterApplied">
            <span class="uitk-icon uitk-icon-trash_delete " (click)="removeFilter(gridFilter)"></span>
            {{ gridFilter.columnName }} = {{ gridFilter.filterValue}}
        </div>
    </span>
</div>
